import styled from 'styled-components';

export const DepositQRCodeMobileStyled = styled.div`
    padding: 24px 16px 16px;
    color: var(--color-white-95);
    display: flex;
    flex-direction: column;
    align-items: center;
    
    p {
        margin-bottom: 0;
    }
`;

export const DepositQRCodeMobileDescriptionStyled = styled.p`
    font-size: 16px;
    font-weight: 700;
    margin-top: 12px;
`;

export const DepositQRCodeMobileAmountStyled = styled.p`
    font-size: 24px;
    font-weight: 600;
    margin-top: 12px;
`;

export const DepositQRCodeMobileTotalAmountStyled = styled.div`
    display: flex;
    justify-content: space-between;
    background: var(--background-positive-20);
    padding: 16px;
    border-radius: 16px;
    width: 100%;
    margin-top: 16px;
    
    span:first-child {
        font-size: 14px;
        font-weight: 400;
        color: var(--color-white-60);
    }

    span:last-child {
        font-size: 16px;
        font-weight: 600;
        color: var(--color-positive);
    }
`;

export const DepositQRCodeMobileContentStyled = styled.div`
    margin-top: 24px;
    border-top: 1px solid var(--color-base-secondary);
    padding-top: 24px;
    width: 100%;
`;

export const DepositQRCodeMobileContentTitleStyled = styled.h3`
    font-weight: 600;
    font-size: 20px;
`

export const DepositQRCodeMobileStepsStyled = styled.div`
    width: 100%;
    margin-left: -32px;
    margin-top: 12px;
`;

export const DepositQRCodeMobileSubmitButtonWrapperStyled = styled.div`
    display: flex;
    flex: 1;
    position: fixed;
    padding: 16px 16px 24px;
    bottom: 0;
    left: 0;
    width: 100%;
    backdrop-filter: blur(4px);
    > button {
        flex: 1;
    }
`;